import {
  GET_LIST_CHOICE,
  GET_LIST_CHOICE_SUCCESS,
  GET_LIST_CHOICE_BY_ID,
  GET_LIST_CHOICE_BY_ID_SUCCESS,
  POST_LIST_CHOICE,
  POST_LIST_CHOICE_SUCCESS,
  PATCH_LIST_CHOICE_BY_ID,
  PATCH_LIST_CHOICE_BY_ID_SUCCESS,
  DELETE_LIST_CHOICE_BY_ID,
  DELETE_LIST_CHOICE_BY_ID_SUCCESS,
} from "./constants"

export function getListChoicesAction() {
  return {
    type: GET_LIST_CHOICE,
  }
}
// GET
export function getListChoicesSuccess(payload) {
  return {
    type: GET_LIST_CHOICE_SUCCESS,
    payload: payload,
  }
}

export function getListChoiceByIdAction(payload) {
  return {
    type: GET_LIST_CHOICE_BY_ID,
    payload: payload,
  }
}

export function getListChoiceByIdSuccess(payload) {
  return {
    type: GET_LIST_CHOICE_BY_ID_SUCCESS,
    payload: payload,
  }
}
// POST
export function postListChoiceAction(payload) {
  return {
    type: POST_LIST_CHOICE,
    payload: payload,
  }
}

export function postListChoiceSuccess(payload) {
  return {
    type: POST_LIST_CHOICE_SUCCESS,
    payload: payload,
  }
}
// PATCH
export function patchListChoiceByIdAction(payload) {
  return {
    type: PATCH_LIST_CHOICE_BY_ID,
    payload: payload,
  }
}

export function patchListChoiceByIdSuccess(payload) {
  return {
    type: PATCH_LIST_CHOICE_BY_ID_SUCCESS,
    payload: payload,
  }
}
// DELETE
export function deleteListChoiceByIdAction(payload) {
  return {
    type: DELETE_LIST_CHOICE_BY_ID,
    payload: payload,
  }
}

export function deleteListChoiceByIdSuccess(payload) {
  return {
    type: DELETE_LIST_CHOICE_BY_ID_SUCCESS,
    payload: payload,
  }
}
